import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPause = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 7,
		y: 5.5,
		width: 3.5,
		height: 13,
		rx: 1,
		fill: "#323232"
	}), /* @__PURE__ */ _jsx("rect", {
		x: 13.5,
		y: 5.5,
		width: 3.5,
		height: 13,
		rx: 1,
		fill: "#323232"
	})]
});
const ForwardRef = forwardRef(SvgPause);
export default ForwardRef;
